import React from 'react';
import { mergeClasses, Image } from '@fluentui/react-components';

import { Video } from 'src/models/Video';
import { PLAY_IMG } from 'src/utils/constants';
import { useVideoThumbnailStyles } from './VideoThumbnail.styles';

interface VideoThumbnailProps {
  onPlay: () => void
  videoInfo: Video
  mediaContentClassName?: string
  className?: string
}

const VideoThumbnail: React.FC<VideoThumbnailProps> = ({ onPlay, videoInfo, mediaContentClassName, className }) => {
  const styles = useVideoThumbnailStyles();
  const announcement = `Play ${videoInfo.videoHeadline} video`;

  const onPlayVideoKeyDown = (keyboard: React.KeyboardEvent<HTMLImageElement>): void => {
    if (keyboard.key === 'Enter') {
      keyboard.preventDefault();
      onPlay();
    }
  };

  if (!videoInfo?.videoId || !videoInfo?.mediaUrl) {
    return (
      <div className={mergeClasses('no-video', styles.noVideo)} data-testid="no-video">
        No video
      </div>
    );
  }

  return (
    <div className={mergeClasses('video-thumbnail', styles.container, className)} data-testid="video-thumbnail">
      <Image
        src={videoInfo.thumbnailSrc}
        className={mediaContentClassName}
        alt=""
        role="presentation"
        data-testid="thumbnail-img"
      />
      <Image
        src={PLAY_IMG}
        alt={announcement}
        aria-label={announcement}
        tabIndex={0}
        onClick={onPlay}
        onKeyDown={onPlayVideoKeyDown}
        className={styles.playBtn}
        role="button"
        data-testid="play-video-btn"
      />
    </div>
  );
};

export default VideoThumbnail;
